import React from "react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { animations } from "helpers/animations";

export const GlobalBox = ({ children, icon = null, controls = null }) => {
  return (
    <Card className={animations.fadeIn}>
      <CardHeader
        color="info"
        icon
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {icon ? <CardIcon color="info">{icon}</CardIcon> : null}
        <div
          style={{
            display: "flex",
            gap: 8,
            justifyContent: "flex-end",
          }}
        >
          {controls}
        </div>
      </CardHeader>
      <CardBody>{children}</CardBody>
    </Card>
  );
};
